import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import './QnaStyle.css';
import { Container, Col, Row, Card, Accordion, Table } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel'
import ClipLoader from "react-spinners/ClipLoader";
import Modal from 'react-modal'
import axios from 'axios';
import moment from 'moment';

import firebase from 'lib/firebase';
import api from 'lib/api';
import global from 'lib/global';
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';
import HeaderWrite from '../Components/HeaderWrite';

import * as UserActions from 'store/modules/UserModule';


class QnaListScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // 알림모달
            visibleAlert: false,
            alert: "",

            // 마이페이지
            userInfo: {},

            // QnA
            qnaData: [],
            page: 0,
            pageAll: 0,
            slicePageStart: 0,
        }
    }

    componentDidMount() {
        const self = this;

        firebase.auth().onAuthStateChanged(async function (user) {
            let userData = await self.props.userActions.getUserInfo();
            if (userData.data.result) {
                self.setState({ userInfo: userData.data.data });
            }
        });

        this.dataLoad();
    }

    dataLoad = async (e) => {
        const self = this;

        api.post('/workbook/qna/list', e)
            .then(function (result) {
                if (result) {
                    let data = result.data.data;
                    // console.log("connet?", data)

                    self.setState({
                        qnaData: data.list,
                        pageAll: data.page_all,
                    });
                }
            })
            .catch(err => {
                console.log("err", err)
            })
    }

    onClickLogout = () => {
        console.log("click Logout")
        const self = this;

        firebase.auth().signOut().then(() => {
            console.log("Logout")
            self.props.userActions.setUserInfo({});
            self.setState({ userInfo: {} })
        }).catch((error) => {
            console.log("Logout err")
        });
    }

    onClickList = (e, row, rowIndex) => {
        let data = row;
        let idx = row.idx;
        let view = row.views;

        api.post('/workbook/qna/viewcount', { qnaIdx: idx, views: view })
            .then(function (result) {
                if (result) {
                    // console.log("view +1")
                }
            })
            .catch(err => {
                console.log("err: ", err)
            })

        this.props.history.push({ pathname: `/qna/${row.idx}`, state: { data: data } });
    }

    onClickNew = () => {
        if (this.state.userInfo.idx > 0) {
            this.props.history.push({ pathname: `/qna/new`, state: { data: null, userIdx: this.state.userInfo.idx, postType: 0 } })
        } else {
            alert("로그인해주세요")
        }
    }

    // page counting
    onClickPagePrev = () => {
        let pageCount = this.state.page - 1;
        if (this.state.page > 0) {
            this.setState({ page: pageCount });
            this.dataLoad({ page: pageCount, });

            if (pageCount > 8 && pageCount % 9 === 0) {
                // console.log("preeee")
                this.setState({ slicePageStart: this.state.slicePageStart - 10 })
            }
        } else {
            console.log("no less pages")
        }
    }

    onClickPageUnique = (i) => {
        let pageCount = i.target.innerText - 1;
        if (this.state.page != pageCount) {
            this.setState({ page: pageCount });
            this.dataLoad({ page: pageCount });
        }

    }

    onClickPageNext = () => {
        let pageCount = this.state.page + 1;
        if (this.state.page < this.state.pageAll - 1) {
            this.setState({ page: pageCount });
            this.dataLoad({ page: pageCount });

            if (pageCount > 9 && pageCount % 10 === 0) {
                // console.log("nexxxxx")
                this.setState({ slicePageStart: this.state.slicePageStart + 10 })
            }
        } else {
            console.log("no more pages")
        }
    }


    render() {
        // console.log("userinfo:", this.state.page)
        // pagination
        let pages = [];
        let i = 0;
        for (i = 0; i < this.state.pageAll; i++) {
            let item = <a onClick={(i) => this.onClickPageUnique(i)} style={i == this.state.page ? { padding: 5, color: "red" } : { padding: 5, color: "blue" }}>{i + 1}</a>;
            pages.push(item)
        }
        let slicePages = pages.slice(this.state.slicePageStart, this.state.slicePageStart + 10)


        // change date's format
        let qnaListData = [];
        this.state.qnaData.forEach(function (data, index) {
            console.log(data)
            let item = data;
            item['write_date'] = moment(data.posting_date).format("YY-MM-DD");
            item['list_index'] = item.group_order > 0 ? "" : item.group_original_num;

            if(data.edit_type > 0){
                item['write_date'] = moment(data.edit_date).format("YY-MM-DD");
            }

            qnaListData.push(item)
        });

        return (
            <div id="qna">
                {/* header */}
                {/* <HeaderWrite /> */}
                <Container>
                    <Row>
                        <a onClick={() => this.onClickPagePrev()}>
                            <img src={"/write/icon_arrow.png"} alt="left" style={{ width: 15, height: 17, cursor: 'pointer' }} />
                        </a>
                        {slicePages}
                        {/* <span style={{ color: '#0f869c' }}>{this.state.page + 1} / {this.state.pageAll}</span> */}
                        <a onClick={() => this.onClickPageNext()}>
                            <img src={"/write/icon_arrow.png"} alt="left" style={{ width: 15, height: 17, cursor: 'pointer', transform: 'rotate(0.5turn)' }} />
                        </a>
                    </Row>
                </Container>
                <BootstrapTable
                    keyField="id"
                    data={qnaListData}
                    hover
                    condensed
                    columns={[
                        { dataField: 'list_index', text: 'No.' },
                        { dataField: 'title', text: 'Title' },
                        { dataField: 'nick_name', text: 'Name' },
                        { dataField: 'write_date', text: 'Date' },
                        { dataField: 'views', text: 'View' },
                        { dataField: 'file', text: 'File' }
                    ]}
                    rowEvents={{
                        onClick: (e, row, rowIndex) => this.onClickList(e, row, rowIndex),
                        // onMouseEnter: (e, row, rowIndex) => {
                        //     console.log(`enter on row with index: ${rowIndex}`);
                        // }
                    }}
                    style={{ backgroundColor: "yellow" }}
                />

                <div onClick={this.onClickNew} style={{ backgroundColor: "orange" }}>New</div>
                <div onClick={this.onClickLogout} style={{ backgroundColor: "yellow" }}>Logout</div>

                <footer>
                    <img src={"/write/ad_logo_icon.png"} alt="boomco logo" style={{ height: '100%', marginBottom: '1%' }} />
                    <p>Copyright 2021. boomco</p>
                    <p>1:1 Customer Center : <a href="mailto:boomco@boomco.org">boomco@boomco.org</a></p>
                </footer>

                {/* modal(경고문) */}
                {/* <Modal
                    isOpen={this.state.visibleAlert}
                    onRequestClose={() => this.setState({ visibleAlert: false })}
                    className="Alert"
                    overlayClassName="Overlay"
                >
                    <Container>
                        <Row>
                            <Col xs={2} sm={2} md={2} lg={2} className="my-auto">
                                <img src={"/write/ad_logo_icon.png"} alt="logo" style={{ width: '140%' }} />
                            </Col>
                            <Col xs={10} sm={10} md={10} lg={10} className="my-auto">
                                <div style={{ color: '#666' }}>{this.state.alert}</div>
                            </Col>
                        </Row>
                        <div className="alertClose" onClick={() => this.setState({ visibleAlert: !this.state.visibleAlert })}>Close</div>
                    </Container>
                </Modal> */}
            </div>
        )
    }
}




let mapStateToProps = (state) => ({
    // userInfo: JSON.parse(JSON.stringify(state.UserModule.get('userInfo'))),
});

let mapDispatchToProps = (dispatch) => ({
    userActions: bindActionCreators(UserActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(QnaListScreen);